// The top-bar Help menu: the page guide, the docs and live chat in one place.
export const helpMenuTestIds = {
  trigger: 'help-menu-trigger-button',
  menu: 'help-menu',
  guideItem: 'help-menu-guide-item',
  docsItem: 'help-menu-docs-item',
  chatItem: 'help-menu-live-chat-item',
  urgentItem: 'help-menu-urgent-escalation-item',
  chatCloseButton: 'support-chat-close-button',
} as const;
